import { render, staticRenderFns } from "./HotelHomeStay.vue?vue&type=template&id=680b4fb8&scoped=true&"
import script from "./HotelHomeStay.vue?vue&type=script&lang=js&"
export * from "./HotelHomeStay.vue?vue&type=script&lang=js&"
import style0 from "./HotelHomeStay.vue?vue&type=style&index=0&id=680b4fb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680b4fb8",
  null
  
)

export default component.exports